const MAX_ORG_NAME_LENGTH = 255

// Reject C0 control characters (0x00-0x1F, includes newlines/null) and DEL (0x7F).
const isControlChar = (char: string) => {
  const code = char.charCodeAt(0)
  return code <= 0x1f || code === 0x7f
}

// Workspace names are emailed to arbitrary invitee addresses, so a URL or domain in
// the name turns invites into a spam/phishing vector. Reject any
// scheme (`https://`, `mailto:`...), a `www.` prefix, or a bare domain like
// `example.com` / `foo.io/path`. A TLD requires 2+ ASCII letters after the
// dot, so `Smith & Co.` and `Team 2.0` are still accepted.
const URL_LIKE =
  /[a-z][a-z0-9+.-]*:\/\/|\bwww\.|\b[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.[a-z]{2,}\b/i

export const validateOrgName = (name: string) => {
  const trimmed = name.trim()
  if (trimmed.length === 0) {
    return 'Name cannot be empty'
  }
  if (trimmed.length > MAX_ORG_NAME_LENGTH) {
    return `Name must be ${MAX_ORG_NAME_LENGTH} characters or fewer`
  }
  if ([...trimmed].some(isControlChar)) {
    return 'Name cannot contain control characters'
  }
  if (URL_LIKE.test(trimmed)) {
    return 'Name cannot contain a URL or web address'
  }
  return true
}
